import { combineReducers } from 'redux';
import { IAction } from '../../components/action/types';
import { Actions, ActionTypes } from './actions';

const replacePropertyActions = (id: number, oldActions: IAction[], newActions: IAction[]) => oldActions
	.filter(({ consumer }) => !(consumer.type === 'property' && consumer.id === id))
	.concat(newActions);

export const byOwnerId = (
	state = {} as { [id: string]: IAction[] }, action: Actions = {} as any
) => {
	switch (action.type) {
		case ActionTypes.CUSTOMER_GET_ACTIONS_RECEIVE:
			return {
				...state,
				[action.payload.customerId]: action.payload.actions
			};
		case ActionTypes.PROPERTY_GET_ACTIONS_RECEIVE:
			return {
				...state,
				[action.payload.customerId]: replacePropertyActions(
					action.payload.propertyId,
					state[action.payload.customerId] || [],
					action.payload.actions
				)
			};
		default:
			return state;
	}
};

export interface ICustomerPageState {
	byOwnerId: ReturnType<typeof byOwnerId>;
}

export default combineReducers<ICustomerPageState>({
	byOwnerId,
});
